module.exports = __webpack_public_path__ + "img/positive.356b7b7c.png";